var GeolocationControl = (function() {
  'use strict';

  var geolocateControl = null;
  var marker = null;
  var mapGL = null;
  var errorPopup = null;

  var handleNoGeolocation = function(msg) {

    var popupContent = '<div class="has-text-centered">' + msg + '</div>';

    if (errorPopup.isOpen()) {
      errorPopup.remove();
    }

    errorPopup.setLngLat(mapGL.getMapObject().getCenter()).setHTML(popupContent).addTo(mapGL.getMapObject());

    setTimeout(function() {
      errorPopup.remove();
    }, 3000);
  };

  return {
    handleNoGeolocation: handleNoGeolocation,

    init: function(map) {
      mapGL = map;

      var thisObj = this;

      geolocateControl = new maplibregl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
          timeout: 6000
        },
        trackUserLocation : false,
        showUserLocation: false
      });

      if (window.matchMedia("(max-width: 767px)").matches) {
        mapGL.getMapObject().addControl(geolocateControl, 'top-left');
      } else {
        mapGL.getMapObject().addControl(geolocateControl, 'bottom-right');
      }

      var el = document.createElement('div');
      el.className = 'icon-map-geolocation';

      marker = new maplibregl.Marker({element: el, anchor: 'bottom'});

      var markerElement = marker.getElement();
      markerElement.addEventListener('mouseenter', function(e){
        mapGL.tooltip.setHTML(thisObj.getPopupContent($(this).data('address')));
        mapGL.tooltip.setLngLat([$(this).data('lng'), $(this).data('lat')]).addTo(mapGL.getMapObject());
      });

      markerElement.addEventListener('mouseleave', () => mapGL.tooltip.remove());

      geolocateControl.on('geolocate', function(e) {
        mapGL.popup = new maplibregl.Popup({
          closeButton: false,
          closeOnClick : true,
          offset: 10,
          className: 'popup-geolocate'
        });

        marker.setLngLat([e.coords.longitude, e.coords.latitude]).addTo(mapGL.getMapObject());
        marker.getElement().setAttribute('data-lng', e.coords.longitude);
        marker.getElement().setAttribute('data-lat', e.coords.latitude);

        Geocoder.reverseGeocode([e.coords.longitude, e.coords.latitude], function(e) {
          marker.getElement().setAttribute('data-address', e.adresse);
        });
      });

      geolocateControl.on('error', function(e) {
        handleNoGeolocation("Votre position ne peut pas être déterminée.");
      });

      geolocateControl.on('outofmaxbounds', function() {
        handleNoGeolocation("Votre position est située en dehors de la zone de couverture de la carte.");
      });

      errorPopup = new maplibregl.Popup({
        closeButton: false,
        closeOnClick : true,
        anchor: "center",
        className: 'popup-geolocation-error',
        focusAfterOpen: false
      });
    },

    removeMarker: function() {
      if (typeof marker !== "undefined") {
        marker.remove();
      }
    },

    getPopupContent: function(address) {
      var popupContent = '<div class="map-popup">';
      popupContent += '<div class="map-popup__address">' + address + '</div>';
      popupContent += '</div>';

      return popupContent;
    }
  };

}());
